import testimonialPicture1 from 'src/assets/images/avatars/6.jpg'
import testimonialPicture2 from 'src/assets/images/avatars/2.jpg'
import testimonialPicture3 from 'src/assets/images/avatars/9.jpg'

export const paywallTempObject = {
  trialFeatures: [],
  plans: [
    { id: 'free', title: 'Free', subText: '', featureList: ['someText', 'someOtherText'] },
    {
      id: 'premuim',
      title: 'Premuim',
      subText: 'AUMHUM Premuim',
      recommended: true,
      featureList: ['someText', 'someOtherText', 'Some Feature', 'Some Other Feature'],
    },
    {
      id: 'family',
      title: 'Family',
      subText: 'AUMHUM Family Plan',
      featureList: ['someText', 'someOtherText', 'Some Feature', 'Some Other Feature'],
    },
  ],
  testimonials: [
    {
      id: 'tst-1',
      name: 'Shourya Rohilla',
      profileIcon: testimonialPicture1,
      language: 'en',
      comment: 'AUMHUM is the best!',
    },
    {
      type: 'hero',
      id: 'tst-2',
      name: 'Harsh Wadhwa',
      profileIcon: testimonialPicture2,
      language: 'en',
      comment: 'My life changed after using AUMHUM!',
    },
    {
      id: 'tst-3',
      language: 'en',
      name: 'Yusuf Khalil',
      profileIcon: testimonialPicture3,
      comment:
        'It’s important to work in your inner peace , and this app is incredible for that purpose. Great user interaction, good music , high quality videos.',
    },
  ],
}
